module.exports = __webpack_public_path__ + "img/12-result.95bb9ee2.png";